import { Lock, ICON_SIZE, ICON_STROKE } from '@/components/icons'

/** The user is signed in and lacks the permission. */
export function DeniedState({
  what = 'this page',
  permission,
}: {
  what?: string
  permission?: string
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
      <Lock size={ICON_SIZE.lg} strokeWidth={ICON_STROKE} aria-hidden className="text-subtle" />
      <p className="text-h3 font-semibold text-text">You do not have access to {what}</p>
      <p className="max-w-sm text-sm text-muted">
        Your role does not include this. Ask a Super Admin if you need it.
      </p>
      {permission && (
        <p className="mt-1 font-mono text-xs text-subtle">Requires: {permission}</p>
      )}
    </div>
  )
}
